import { render } from "./MailControlsBox.vue?vue&type=template&id=01eaa737"
import script from "./MailControlsBox.vue?vue&type=script&lang=js"
export * from "./MailControlsBox.vue?vue&type=script&lang=js"

import "./MailControlsBox.vue?vue&type=style&index=0&id=01eaa737&lang=sass"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__